module.exports = [{
      plugin: require('/Users/mihov/here/projects/my-react-app/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
